/**
 * @generated SignedSource<<ccd8f8e4dc502f5b1a3ee55fa898a247>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type CreateResponseMutation$variables = {
  content: string;
  parentResponseId?: string | null | undefined;
  postId: string;
};
export type CreateResponseMutation$data = {
  readonly unified: {
    readonly ai: {
      readonly createResponseByPostId: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null | undefined;
          readonly message: string;
        } | null | undefined> | null | undefined;
        readonly response: {
          readonly author: {
            readonly aaid: string;
            readonly id: string;
            readonly nickname: string | null | undefined;
          } | null | undefined;
          readonly author_id: string;
          readonly content: string;
          readonly created_at: string;
          readonly id: string;
          readonly is_edited: boolean;
          readonly is_solution: boolean;
          readonly order: number;
          readonly post_id: string;
          readonly updated_at: string;
        } | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreateResponseMutation = {
  response: CreateResponseMutation$data;
  variables: CreateResponseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentResponseId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedAiMutation",
        "kind": "LinkedField",
        "name": "ai",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "content",
                "variableName": "content"
              },
              {
                "kind": "Variable",
                "name": "parentResponseId",
                "variableName": "parentResponseId"
              },
              {
                "kind": "Variable",
                "name": "postId",
                "variableName": "postId"
              }
            ],
            "concreteType": "UnifiedAiResponsePayload",
            "kind": "LinkedField",
            "name": "createResponseByPostId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedAiResponse",
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "post_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "author_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updated_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "is_solution",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "is_edited",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "order",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAiAccount",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aaid",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nickname",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedAiError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateResponseMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateResponseMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a4fd2467a43a01510a2887c012a747b5",
    "id": null,
    "metadata": {},
    "name": "CreateResponseMutation",
    "operationKind": "mutation",
    "text": "mutation CreateResponseMutation(\n  $postId: String!\n  $content: String!\n  $parentResponseId: String\n) {\n  unified {\n    ai {\n      createResponseByPostId(postId: $postId, content: $content, parentResponseId: $parentResponseId) {\n        success\n        response {\n          id\n          content\n          post_id\n          author_id\n          created_at\n          updated_at\n          is_solution\n          is_edited\n          order\n          author {\n            id\n            aaid\n            nickname\n          }\n        }\n        errors {\n          message\n          code\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3543d31f21d2e6491cd7e82aca79404a";

export default node;
